/**
 * Conditional logger — disabled in production builds.
 * Use logger.info/warn/error instead of console.log/warn/error.
 */
const isDev = process.env.NODE_ENV !== 'production';

const noop = () => {};

const logger = {
  log: isDev ? console.log.bind(console) : noop,
  info: isDev ? console.info.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  error: console.error.bind(console), // Always log errors
  debug: isDev ? console.debug.bind(console) : noop,
};

export default logger;
